import {Directive, HostBinding, HostListener, Input, Attribute, ContentChildren, QueryList } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, RouterLinkWithHref, ActivatedRoute, RouterLinkActive } from '@angular/router'

import { NavigationCountService } from './navigation-count-service' ;
import { ExtendedRouterLinkWithHrefDirective } from './extended-routerlinkwithhref-directive' ;

// Config from :   assets/config.js
declare var config: any;

@Directive({
  selector: '[extendedRouterLinkActive]'
})
export class ExtendedRouterLinkActiveDirective extends RouterLinkActive {

  @ContentChildren(ExtendedRouterLinkWithHrefDirective, {descendants: true})
  linksWithHrefs: QueryList<RouterLinkWithHref>;

  @Input('extendedRouterLinkActive')
  set extendedRouterLinkActive(data: string[]|string) {
    this.routerLinkActive = data ; 
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit() ;
  }  


}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/extended-routerlinkactive-directive.ts